import { render } from "./CourseUserCardSkeleton.vue?vue&type=template&id=b4795462&scoped=true"
import script from "./CourseUserCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CourseUserCardSkeleton.vue?vue&type=script&lang=js"

import "./CourseUserCardSkeleton.vue?vue&type=style&index=0&id=b4795462&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4795462"]])

export default __exports__